// njoy-header.js — Hover-open mega-menu (desktop ≥990px only)
// Bổ sung mouseenter/mouseleave cho HeaderMenu mà không sửa details-disclosure.js

(function () {
  const OPEN_DELAY  = 100; // ms delay trước khi mở
  const CLOSE_DELAY = 200; // ms delay trước khi đóng (tránh đóng ngay khi di chuột qua gap)

  function openMenu(details) {
    details.setAttribute('open', '');
    details.querySelector('summary').setAttribute('aria-expanded', 'true');
  }

  function closeMenu(details) {
    details.removeAttribute('open');
    details.querySelector('summary').setAttribute('aria-expanded', 'false');
  }

  function setupHoverMenu() {
    document.querySelectorAll('header-menu').forEach(function (el) {
      var details = el.querySelector('details');
      if (!details) return;

      var openTimer  = null;
      var closeTimer = null;

      el.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        openTimer = setTimeout(function () { openMenu(details); }, OPEN_DELAY);
      });

      el.addEventListener('mouseleave', function () {
        clearTimeout(openTimer);
        closeTimer = setTimeout(function () { closeMenu(details); }, CLOSE_DELAY);
      });
    });
  }

  // Chỉ chạy trên desktop ≥990px
  var mq = window.matchMedia('(min-width: 990px)');

  function onMQChange(e) {
    // Không có cleanup API đơn giản — chỉ init một lần khi desktop
    if (e.matches) setupHoverMenu();
  }

  if (mq.matches) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setupHoverMenu);
    } else {
      setupHoverMenu();
    }
  }

  mq.addEventListener('change', onMQChange);
})();
